module.exports = __webpack_public_path__ + "img/coupon-icon-4.139287f7.png";